/* eslint-disable sort-keys */
import { AxiosResponse } from 'axios'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { RequestCDU, RequestREAD } from 'services/Instances'

export function AnalyzeCREServices() {
  const path = 'CreItem'
  const getAll = async (
    requestGet: RequestGetAllCRE
  ): Promise<AxiosResponse<IPaginatedResponse<ResponseAnalyseCRE>>> =>
    RequestREAD.get(path + '/GetAllByFilter', {
      params: requestGet
    })

  const generalSearch = async (
    query: string,
    pageSize: number,
    pageNumber: number
  ): Promise<AxiosResponse<IPaginatedResponse<ResponseAnalyseCRE>>> =>
    RequestREAD.get(path + '/PesquisaGeral', {
      params: { pageNumber, pageSize, query }
    })

  return { generalSearch, getAll }
}

export function AddAnalyzeCREServices() {
  const path = 'Cre'

  const pathSessaoCre = async (obj: sessaoCre): Promise<AxiosResponse> =>
    await RequestCDU.patch(path + '/SetEmAnaliseSessao', obj)

  const getAnaliseCREInicial = (
    requestGet: RequestAnaliseCREInicial
  ): Promise<AxiosResponse<ResponseAnaliseCREInicial>> =>
    RequestREAD.get(path + '/AnaliseCREInicial', {
      params: requestGet
    })

  const verificarCreExistente = (
    cre: RequestCreExistente
  ): Promise<AxiosResponse<CreExistenteDto>> =>
    RequestREAD.get(path + '/HasCreExist', {
      params: cre
    })

  const setDisponibilidade = async (
    obj: RequestSetDisponibilidade
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(
      path + `/SetDisponibilidade?creId=${obj.creId}&ocuparCre=${obj.ocuparCre}`
    )

  const verificarDisponibilidadeCre = async (
    obj: number[]
  ): Promise<AxiosResponse<DisponibilidadeResponse>> =>
    await RequestREAD.post(path + '/GetStatusOcupado', obj)


  const manterCreOcupado = async (
    obj: RequestSetDisponibilidade
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(path + `/ManterCreOcupado?creId=${obj.creId}`)

  const createCREAnalise = async (
    requestObj: RequestCreateCreAnalise
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(path + '/CreateCREAnalise', requestObj)

  const updateCREAnalise = async (
    requestObj: RequestUpdateCreAnalise
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(path + '/UpdateCreAnalise', requestObj)

  const createCodigoCRE = async (
    requestObj: RequestCreateCodigoCRE
  ): Promise<AxiosResponse<ResponseCreateCodigoCRE>> =>
    await RequestCDU.post(path + '/CreateAndRemoveCodigoCRE', requestObj)

  const searchCre = async (
    requestGet: RequestGetAllCRE
  ): Promise<
    AxiosResponse<
      IGenericEntityResponse<IPaginatedResponse<ResponseAnalyseCRE>>
    >
  > =>
    RequestREAD.get(path + '/PesquisaCre', {
      params: requestGet
    })

  const getMovimentacao = async (
    idMov: number
  ): Promise<AxiosResponse<ResponseMovimentacao>> =>
    await RequestREAD.get(`Movimentacao/${idMov}`)

  const getEfetivoMovimentacao = async ({
    IdMovimentacao,
    PageNumber,
    PageSize
  }: IGetEfetivoMovimentacao): Promise<
    AxiosResponse<IResponseEfetivoMovimentacao>
  > =>
    await RequestREAD.get(`MovEfetivo/EfetivoMovimentacao/`, {
      params: {
        IdMovimentacao,
        PageNumber,
        PageSize
      }
    })

  const createMovDocumento = async (
    requestObj: RequestCreateItemAnalise[]
  ): Promise<AxiosResponse<RequestCreateItemAnalise[]>> =>
    await RequestCDU.post(`MovDocumento/CreateRangeReturn`, requestObj)

  const getDocMov = async (
    idMov: number
  ): Promise<AxiosResponse<RequestCreateItemAnalise[]>> =>
    await RequestREAD.get(`MovDocumento/DocsPendentes/${idMov}`)

  return {
    createCREAnalise,
    createCodigoCRE,
    createMovDocumento,
    getAnaliseCREInicial,
    getDocMov,
    getMovimentacao,
    getEfetivoMovimentacao,
    manterCreOcupado,
    pathSessaoCre,
    searchCre,
    setDisponibilidade,
    updateCREAnalise,
    verificarCreExistente,
    verificarDisponibilidadeCre
  }
}

export function MovDocumentoServices() {
  const path = 'MovDocumento'

  const create = async (
    requestObj: RequestCreateMovDoc
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(path + '/Create', requestObj)
  return { create }
}

export interface RequestGetAllCRE {
  Contrato?: string
  NmFornecedor?: string
  CRE?: string
  BloqPagamento?: boolean
  BloqCre?: boolean
  MesAnoVerificacao?: string
  DataInicioLiberacao?: string
  DataFimLiberacao?: string
  DataInicioRetorno?: string
  DataFimRetorno?: string
  pageNumber: number
  pageSize: number
}

export interface IPaginatedResponse<TPaginatedData> {
  items: TPaginatedData[]
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: Boolean
  hasNextPage: Boolean
  isFirstPage: Boolean
  isLastPage: Boolean
  firstItemOnPage: number
  lastItemOnPage: number
}

export interface ResponseAnalyseCRE {
  idCreItem: number
  idCre?: number
  creId: number
  movDocumentoId: number
  txObservacao?: any
  cdCre?: any
  cre?: string
  analista?: string
  bloqCre?: boolean
  bloqPag?: boolean
  nuRisco: number
  cdMatricula: string
  dataLiberacao: Date
  dataRetorno: Date
  dtAnalise: Date
  idContrato: number
  dtUltAnalise: Date
  flCreBloqueado: boolean
  contrato: string
  fornecedor?: string
  nmFornecedor?: any
  competencia: number
  usuarioAnalista?: any
  status: string
}

export interface RequestAnaliseCREInicial {
  CdContrato: string
  NuAnoMesCompetencia: string
}
export interface ResponseAnaliseCREInicial {
  idCre: number
  idMovimentacao: number
  idContrato: number
  idFornecedor: number
  cdCre: string
  cdContrato: number
  flFornecedorBloqueadoPagamento: boolean
  nmFornecedor: string
  fornecedor?: string
  txObjetoContrato: string
  flMobilizacao: boolean
  flContratoPrincipalExistente: boolean
  txCNO: string
  cdContratoPrincipal: number
  nmFornecedorPrincipal?: any
  txObjetoContratoPrincipal?: any
  dtEntradaCRE: Date
  dtLiberacaoCRE: Date
  dtRetornoCRE: Date
  qtAnalises: number
  nuDas: number
  nuGfip: number
  flChecklist: boolean
  nuGps: number
  flDenuncia: boolean
  flAlerta: boolean
  txDenuncia: string
  txAlerta: string
  flBloqueado: boolean
  flLiberado: boolean
  nmAnalista: string
  txObservacao: string
  cdMatricula: string
  creDisponivel?: boolean
  vlDas: number
  vlGfip: number
  vlGps: number
  cdDocto: string
}

export interface RequestCreateMovDoc {
  idMovDocumento?: number
  movimentacaoId: number
  tipoPendenciaId: number
  cdCalcRisco: string
  vlCalcRisco: number
  dtCriacao: Date
  flAnexado: boolean
  txDescricao: string
  flPendente: boolean
}

export interface RequestCreateCodigoCRE {
  creId: number
  idUsuario: number
  create: boolean
}

export interface RequestDeleteCodigoCRE {
  creItemId: number
  matriculaUsuarioLogado: string
  competencia: string
}

export interface ResponseCreateCodigoCRE {
  valor: string
  sucesso: boolean
  mensagem: string
  detalhe?: any
  tipo?: any
  title?: string
}

export interface ResponseMovimentacao {
  idMovimentacao: number
  contratoId: number
  contratoCompartilhadoId?: any
  nuAnoMesCompetencia: number
  flStatusMoblizacao: string
  flValidContraparte: boolean
  cdContraparte: string
  dtValidContraparte: Date
  flValidAnalista: boolean
  cdAnalista: string
  dtValidAnalista: Date
  qtAtivo: number
  qtDemitido: number
  qtAcesso: number
  qtTransferido: number
  qtAfastado: number
  qtCompartilhado: number
  qtClt: number
  qtSocio: number
  qtCooperado: number
  qtEstrangeiro: number
  qtEstagiario: number
  qtAutonomo: number
  qtMei: number
  qtTotalEfetivo: number
  qtNeAnterior: number
  qtNeAtual: number
  vlNeVariacaoAtual: number
  peNePercVarAtual: number
  txNeJustificativa: string
  qtHeQtd: number
  qtHeNormal: number
  peHeVariacao: number
  txHeJustificativa: string
  vlHoraExtras: number
  vlSalBase: number
  vlFolhaPagto: number
  peValVariacao: number
  flMovValida: boolean
  contrato?: any
  contratoCompartilhado?: any
  tCarteiras: any[]
  tMovDocumentos: any[]
  tMovEfetivos: any[]
  tMovEvidenciaGeds: any[]
  numContrato: string
}

export interface IGetEfetivoMovimentacao {
  IdMovimentacao: number
  PageNumber: number
  PageSize: number
}

export interface IResponseEfetivoMovimentacao {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  items: ResponseEfetivoMovimentacao[]
}

export interface ResponseEfetivoMovimentacao {
  idMovEfetivo: number
  cdNacionalidade: string
  cdCpfPassaporte: string
  cdGenero: string
  nmColaborador: string
  cdStatus: string
  dtAdmissao: Date
  dtDemissao?: Date
  cdTipoEfetivo: string
  txFuncao: string
  cdCategoria: string
  nuAnoMesCompetencia: number
  qtCompartilhado: number
  numContrato: string
}

export interface RequestSetDisponibilidade {
  creId: number
  ocuparCre?: boolean
}

export interface RequestCreExistente {
  cdContrato: string
  anoMes: string
}

export interface Historico {
  idMovDocumentoItem?: number
  movDocumentoId: number
  cdGedExternalId: string
  cdStatus: string
  txJustificativa: string
  dtAnexado: string
  dtRetorno: string
  txFileName: string
  txVersao: string
  txObservacaoMovDocItem?: string | undefined
  vlLiberado: number
  cdMatriculaMovItem: string
  dtLibRecMovDocItem: string | Date
}

export interface RequestCreateItemAnalise {
  flDescChange?: boolean
  flQtdPendChange?: boolean
  liberado?: string
  id?: string
  idUsuario?: string
  idCreItem: number
  idMovDocumento: number
  movimentacaoId: number
  movDocumentoItemId: number
  gedExternalId: string
  txTipo: string
  dtAnexado: string
  txDescricaoTipo: string
  txDescricaoAnexo: string
  txJustificativa: string
  tipoPendenciaId: number
  retornoAnalise: string
  cdStatus: string
  flLiberado: boolean
  qtPendencias: number
  cdMatricula: string
  dtLiberacao: string
  competencia: string
  diasPendentes: number
  idContrato: number
  qtdAnalises: number
  vlCalcRisco?: number
  historico?: Historico[]
  showCalcRisco?: string
}

export interface CreAnaliseRequestDto {
  liberado: boolean
  movDocumentoId: number
  creId: number
  usuarioId: number
  flCreBloq: boolean
  observacoo: string
}

export interface CreExistenteDto {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface Valores {
  vlrDAS: number
  vlrGFIP: number
  vlrGPS: number
}

export interface MovDoc {
  idMovDocumento: number
  movimentacaoId: number
  tipoPendenciaId: number
  cdCalcRisco: string
  vlCalcRisco: number
  dtCriacao: string
  flAnexado: boolean
  txDescricao: string
  flPendente: boolean
}

export interface sessaoCre {
  creId: number
  usuarioAnalistaDesignadoId?: number
  emAnalise: boolean
}

export interface RequestCreateCreAnalise {
  creAnaliseRequestDto: CreAnaliseRequestDto[]
  valores: Valores
  movDocs: MovDoc[]
}
export interface CreItensAnalises {
  idCreItem: number
  flLiberacao: string
  dtLiberacaoBloqueio: string
  tipoDocumentoId: number
  vlCalculoRisco: number
  justificativa: string
  observacao: string
  quantidadePendencias: number
}

export interface RequestUpdateCreAnalise {
  idCre: number
  idAnalista: number
  idContrato: number
  qtAnalises: number
  creObservacoes: string
  creItemAnalises: CreItensAnalises[]
  gps: number
  gfip: number
  das: number
  qtTotalEfetivo: number
}

interface DisponibilidadeResponse {
  entity: [
    {
      idCre: number,
      creOcupado: boolean,
      nomeAnalista: string,
      dataAnalise: string,
      status: string
    }
  ],
  sucesso: boolean,
  mensagem: string,
  tipo: any,
  detalhe: string
}
